module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.44.00.9e3a7ed0.jpg";